


































import vuedraggable from "vuedraggable";
import { Component, Vue, Prop } from "vue-property-decorator";
import InputString from "@/views/components/input/InputString.vue";
import { Topics } from "@/models/Topic.ts";

@Component({
  name: "DragListTopic",
  components: {
    draggable: vuedraggable,
    InputString
  }
})
export default class DragListTopic extends Vue {
  @Prop({ default: "Header" })
  public headerText: any;

  @Prop({ default: {} })
  public options: any;

  @Prop({ default: [] })
  public list: any;

  @Prop({ default: {} })
  public addBtn: any;

  idEnabled: number = 0;
  oldIdEnabled: number = 0;

  constructor() {
    super();
  }

  created() {
    let topic = this.list.find((e: Topics) => e.enabled == 1);
    if (topic) {
      this.idEnabled = topic.id;
      this.oldIdEnabled = this.idEnabled;
    }
  }

  get propHeaderText() {
    return this.headerText;
  }

  get propOptions() {
    return this.options;
  }

  get propList() {
    return this.list;
  }

  public onEnd(event: any) {
    console.log("onEnd -> event", JSON.parse(JSON.stringify(this.list)));
  }

  public onEdit(event: any) {
    const index = this.list.findIndex((e: any) => e.id === event.id);
    this.list[index].isEdit = !this.list[index].isEdit;
    if (!this.list[index].isEdit) {
      // this.$emit('onEdit', index);
      this.$emit("onEdit", event);
    }
  }

  // public onDelete(event: any) {
  //   this.$emit('onDelete', event);
  //   // console.log('onDelete -> event', event);
  // }

  onChangeEnabled(item: Topics) {
    item.enabled = 1;
    const enabledItem: Topics= { ...item};
    delete enabledItem.isEdit;
    
    this.$emit("onChangeEnabled", { idDelete: this.oldIdEnabled, enabledItem } );
    if (item.id) {
      this.oldIdEnabled = item.id;
    }
  }
}
